var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#46D339"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.728 29.288C19.576 29.288 18.512 29.064 17.536 28.616C16.56 28.152 15.712 27.512 14.992 26.696C14.272 25.864 13.712 24.888 13.312 23.768C12.912 22.632 12.712 21.392 12.712 20.048C12.712 18.704 12.904 17.472 13.288 16.352C13.688 15.232 14.248 14.256 14.968 13.424C15.688 12.592 16.536 11.952 17.512 11.504C18.504 11.056 19.584 10.832 20.752 10.832C22.336 10.832 23.728 11.248 24.928 12.08C26.144 12.896 26.992 14.016 27.472 15.44L24.952 16.448C24.6 15.472 24.048 14.712 23.296 14.168C22.56 13.624 21.704 13.352 20.728 13.352C19.752 13.352 18.864 13.64 18.064 14.216C17.28 14.776 16.656 15.56 16.192 16.568C15.728 17.576 15.496 18.736 15.496 20.048C15.496 21.36 15.72 22.528 16.168 23.552C16.616 24.56 17.232 25.352 18.016 25.928C18.8 26.488 19.696 26.768 20.704 26.768C21.696 26.768 22.56 26.496 23.296 25.952C24.048 25.392 24.6 24.632 24.952 23.672L27.472 24.68C27.152 25.624 26.664 26.44 26.008 27.128C25.352 27.816 24.576 28.352 23.68 28.736C22.784 29.104 21.8 29.288 20.728 29.288ZM10.672 22.736V20.888H21.376V22.736H10.672ZM10.672 19.208V17.336H21.376V19.208H10.672Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitIcon);
export default __webpack_public_path__ + "static/media/ProfitIcon.f6d0bb4890477aa3c4dac55b2d829cbc.svg";
export { ForwardRef as ReactComponent };